import { __assign, __rest } from "tslib";
import React from 'react';
import clsx from 'clsx';
import { getBaseProps } from '../internal/base-component';
import Alert from '../alert';
import Box from '../box';
import styles from './styles.css.js';
import { useTelemetry } from '../internal/hooks/use-telemetry';
export default function Form(_a) {
    var children = _a.children, header = _a.header, errorText = _a.errorText, actions = _a.actions, rest = __rest(_a, ["children", "header", "errorText", "actions"]);
    useTelemetry('Form');
    var baseProps = getBaseProps(rest);
    return (React.createElement("div", __assign({}, baseProps, { className: clsx(styles.root, baseProps.className) }),
        header && React.createElement("div", { className: styles.header }, header),
        children && React.createElement("div", { className: styles.content }, children),
        React.createElement("div", { "aria-live": "assertive" }, errorText && (React.createElement(Box, { margin: { top: 'l' } },
            React.createElement(Alert, { type: "error" },
                React.createElement("div", { className: styles.error }, errorText))))),
        actions && React.createElement("div", { className: styles.actions }, actions)));
}
//# sourceMappingURL=index.js.map